import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { useState } from "react";
import CustomerExperienceChart from "./MonitoringCallInfo/CustomerExperienceChart";
import TranscriptSummary from "./TranscriptSummary";
import { Theme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TranscriptSummaryViewModel from "./Transcripts/TranscriptSummaryViewModel";

const styles = {
    scroll: {
        backgroundColor: '#fff',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        py: (theme: Theme) => theme.spacing(1),
    }
}
const tabBorderStyle = 'solid 1px black';

const tabStyles = {
    tab: {
        color: '#fff',
        backgroundColor: '#1d8abf',
        borderRadius: 0,
        borderTop: '1px white solid',
        borderBottom: tabBorderStyle,
        '&:hover': {
            backgroundColor: '#1d8abf'
        }
    },
    endTab: {
        color: '#fff',
        backgroundColor: '#1d8abf',
        borderRadius: 0,
        borderTop: '1px white solid',
        borderRight: '1px white solid',
        borderBottom: tabBorderStyle,
        '&:hover': {
            backgroundColor: '#1d8abf'
        }
    },
    selectedTab: {
        backgroundColor: '#fff',
        color: '#1d8abf',
        borderTop: tabBorderStyle,
        borderLeft: tabBorderStyle,
        borderRight: tabBorderStyle + " !important",
        borderRadius: 0,
        '&:hover': {
            backgroundColor: '#fff'
        }
    },
}

interface IVoiceOfTheCustomerSummaryTabProps {
    id: string
    switchCallId?: string
    summary?: TranscriptSummaryViewModel | null
}

export default function VoiceOfTheCustomerSummaryTab(props: IVoiceOfTheCustomerSummaryTabProps) {
    const [selectedTab, setSelectedTab] = useState(0);

    const tabs = [
        { label: "Customer Experience", isAgent: false },
        { label: "Agent Experience", isAgent: true }
    ];

    return (
        <Box sx={styles.scroll}>
            <Grid container spacing={0}>
                <Grid size={12} sx={{ px: 1, pb: 1 }}>
                    <TranscriptSummary summary={props.summary} />
                </Grid>

                <Grid size={12}>
                    <Stack direction="row" alignItems="flex-end">
                        <Stack direction="row" sx={{ width: 'calc(100% * 2 / 7)' }}>
                            {tabs.map((tab, i) => (
                                <Button
                                    key={tab.label}
                                    onClick={() => setSelectedTab(i)}
                                    fullWidth
                                    sx={selectedTab === i ? tabStyles.selectedTab : i === tabs.length - 1 ? tabStyles.endTab : tabStyles.tab}
                                    style={i !== tabs.length - 1 && i !== selectedTab - 1 ? { borderRight: '1px white solid' } : {}}
                                >
                                    {tab.label}
                                </Button>
                            ))}
                        </Stack>

                        <Box sx={{ flexGrow: 1, borderBottom: '1px solid black' }} />
                    </Stack>
                </Grid>

                <Grid size={12} sx={{ px: 1, pt: 1 }}>
                    <CustomerExperienceChart
                        callRefId={props.id}
                        switchCallId={props.switchCallId}
                        isAgent={tabs[selectedTab].isAgent}
                        height="300px"
                    />
                </Grid>
            </Grid>
        </Box>
    );
}